import type { IPublicPostData } from '../../types/post'
import { BackhaulPublicPostCard } from '../shared/backhaul-public-post-card'

interface ICardViewProps {
  posts: IPublicPostData[]
  workspacename: string
  enterpriseWorkspaceID: string | null | undefined
}

const CardView = ({ posts, workspacename }: ICardViewProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {posts.map((post) => (
        <BackhaulPublicPostCard post={post} workspacename={workspacename} key={post.id} />
      ))}
    </div>
  )
}

export default CardView
